import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { KitSlotState } from './kitSlots';
import { kitMessages } from './kitMessages';
import { addedAssetsMessages } from '../../addedAssets/addedAssetsMessages';
import { coverRedoMessages } from './coverRedo/coverRedoMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Kit.module.scss';
/* eslint-enable css-modules/no-unused-class */

const LABEL = {
  made: kitMessages.stateMade,
  making: kitMessages.stateMaking,
  failed: kitMessages.stateNotMade,
  notMade: kitMessages.stateNotMade,
  locked: kitMessages.statePro,
} as const;

const TONE: Record<KitSlotState, string | undefined> = {
  made: styles.stOk,
  making: styles.stWork,
  failed: styles.stBad,
  notMade: styles.stOff,
  locked: styles.stWork,
};

/**
 * The state word of a slot (design assets-rethink b1 `.st`): Made, Making, Not made (red for a
 * failed slot: "made or not made" is the status, the fail reason is the line), Pro (d3). A made
 * slot whose version the artist added says "Added" (design music-video a5, a6). A made slot whose
 * file has an old cover says "Old cover" in amber (design kit-redo-cover a1).
 */
const KitStateChipComponent: React.FC<{ state: KitSlotState; added?: boolean; oldCover?: boolean }> = ({
  state,
  added = false,
  oldCover = false,
}) => {
  const intl = useIntl();
  if (state === 'made' && oldCover && !added) {
    return (
      <span className={clsx(styles.st, styles.stOld)} data-testid="kit-old-cover">
        {intl.formatMessage(coverRedoMessages.slotOldCover)}
      </span>
    );
  }
  const label = state === 'made' && added ? addedAssetsMessages.stateAdded : LABEL[state];
  return <span className={clsx(styles.st, TONE[state])}>{intl.formatMessage(label)}</span>;
};

export const KitStateChip = TypedMemo(KitStateChipComponent);
